"use strict";
// https://www.figma.com/file/l62sFQ3ix9Wc4aV7DF8XHb/MKP-LIGHT?node-id=0%3A7243
// LAST SYNC: 03.01.22
Object.defineProperty(exports, "__esModule", { value: true });
exports.typography = void 0;
exports.typography = {
    h1: {
        fontWeight: 500,
        fontSize: '56px',
        letterSpacing: '-1.5px',
    },
    h2: {
        fontWeight: 500,
        fontSize: '48px',
        letterSpacing: '-0.5px',
    },
    h3: {
        fontWeight: 500,
        fontSize: '36px',
        letterSpacing: '0px',
    },
    h4: {
        fontWeight: 500,
        fontSize: '32px',
        letterSpacing: '0.25px',
    },
    h5: {
        fontWeight: 500,
        fontSize: '24px',
        letterSpacing: '0px',
    },
    h6: {
        fontWeight: 500,
        fontSize: '18px',
        letterSpacing: '0.15px',
    },
    subtitle1: {
        fontWeight: 400,
        fontSize: '16px',
        letterSpacing: '0.15px',
    },
    subtitle2: {
        fontWeight: 500,
        fontSize: '14px',
        letterSpacing: '0.1px',
    },
    body1: {
        fontWeight: 400,
        fontSize: '16px',
        letterSpacing: '0.15px',
    },
    body2: {
        fontWeight: 400,
        fontSize: '14px',
        letterSpacing: '0.15px',
    },
    buttonLarge: {
        fontWeight: 700,
        fontSize: '15px',
        letterSpacing: '0.4px',
    },
    buttonMedium: {
        fontWeight: 500,
        fontSize: '14px',
        letterSpacing: '0.4px',
    },
    buttonSmall: {
        fontWeight: 700,
        fontSize: '13px',
        letterSpacing: '0.4px',
    },
    caption: {
        fontWeight: 400,
        fontSize: '12px',
        letterSpacing: '0.4px',
    },
    overline: {
        fontWeight: 500,
        fontSize: '12px',
        letterSpacing: '1px',
    },
};
//# sourceMappingURL=typography.js.map